import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

// routing components
import Index from "views/Index.jsx";

import PrivacyPage from "views/landing/Privacy.jsx";
import RoygbivPrivacyPage from "views/landing/RoygbivPrivacy.jsx";
import SupportPage from "views/landing/Support.jsx";
// global template script file
import "./laapp.js";

ReactDOM.render(
  <BrowserRouter>
    <Switch>
      <Route path="/" exact render={props => <Index {...props} />} />

      {/* <Route
        path="/alter-1"
        exact
        render={props => <Alternative1 {...props} />}
      />
      <Route
        path="/alter-2"
        exact
        render={props => <Alternative2 {...props} />}
      />
      <Route
        path="/alter-3"
        exact
        render={props => <Alternative3 {...props} />}
      /> */}
      <Route
        path="/support"
        exact
        render={props => <SupportPage {...props} />}
      />

      <Route
        path="/app/morph/privacypolicy"
        exact
        render={props => <PrivacyPage {...props} />}
      />
      <Route
        path="/app/roygbiv/privacypolicy"
        exact
        render={props => <RoygbivPrivacyPage {...props} />}
      />
      {/* Old privacy URLs may be linked from app-store listings — keep them live. */}
      <Redirect from="/privacy" to="/app/morph/privacypolicy" />
      <Redirect from="/policy" to="/app/morph/privacypolicy" />
      {/* Pricing and all Morph-platform specifics live on morphxr.app —
          this site is the studio. */}
      <Route
        path="/pricing"
        exact
        render={() => {
          window.location.replace("https://morphxr.app/pricing");
          return null;
        }}
      />
      <Redirect to="/" />
    </Switch>
  </BrowserRouter>,
  document.getElementById("root")
);
